import React from 'react'

const GreenCheckMark = (props) => (
    <svg {...props} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="22" height="22" rx="5" fill="#7DDE8B"/>
        <path d="M6 11.2776L9.43921 14.6951L16 6.875" stroke="white" strokeWidth="3"/>
    </svg>
)

export default GreenCheckMark;